import { themeObject } from '../../lib';

export const styles = {
    readyOnlyContainer: {
        width: '100%',
        height: '100%',
    },
    textContainer: {
        width: '100%',
        height: '32px',
        alignContent: 'center',
        borderRadius: '4px 4px 0px 0px',
        backgroundColor: themeObject.palette.tertiary.purple[400],
    },
    text: {
        fontFamily: 'Source Code Pro',
        weight: '500',
        fontSize: '14px',
        lineHeight: '17.6px',
        letter: '0.5px',
        color: 'rgba(255, 255, 215, 1)',
        margin: '7px 7px 10px 16px',
    },
};
